import type { OdinIconName } from '../odin-icon/odin-icon.component';

/* Maps font-awesome icon names to their corresponding OdinIconName */
export const iconMap: Record<string, OdinIconName> = {
  ADJUST: 'Settings',
  ALIGN_CENTER: 'AlignCenter',
  ALIGN_JUSTIFY: 'AlignJustify',
  ALIGN_LEFT: 'AlignLeft',
  ALIGN_RIGHT: 'AlignRight',
  AMBULANCE: 'Ambulance',
  ANCHOR: 'Anchor',
  ARCHIVE: 'Archive',
  AREA_CHART: 'ChartArea',
  ARROW_CIRCLE_DOWN: 'ArrowDownCircle',
  ARROW_CIRCLE_LEFT: 'ArrowLeftCircle',
  ARROW_CIRCLE_RIGHT: 'ArrowRightCircle',
  ARROW_CIRCLE_UP: 'ArrowUpCircle',
  ARROW_DOWN: 'ArrowDown',
  ARROW_LEFT: 'ArrowLeft',
  ARROW_RIGHT: 'ArrowRight',
  ARROW_UP: 'ArrowUp',
  ASTERISK: 'Star',
  AT: 'AtSign',
  AUTOMOBILE: 'Car',
  BACKWARD: 'Rewind',
  BALANCE_SCALE: 'Scale',
  BAN: 'Ban',
  BANK: 'Building',
  BAR_CHART: 'BarChart',
  BAR_CHART_O: 'BarChart2',
  BARCODE: 'Barcode',
  BARS: 'Menu',
  BATTERY_0: 'BatteryWarning',
  BATTERY_1: 'BatteryLow',
  BATTERY_2: 'BatteryMedium',
  BATTERY_3: 'Battery',
  BATTERY_4: 'BatteryFull',
  BATTERY_EMPTY: 'BatteryWarning',
  BATTERY_FULL: 'BatteryFull',
  BATTERY_HALF: 'BatteryMedium',
  BATTERY_QUARTER: 'BatteryLow',
  BATTERY_THREE_QUARTERS: 'Battery',
  BED: 'Bed',
  BEER: 'Beer',
  BELL: 'Bell',
  BELL_O: 'Bell',
  BELL_SLASH: 'BellOff',
  BELL_SLASH_O: 'BellOff',
  BICYCLE: 'Bike',
  BINOCULARS: 'Binoculars',
  BIRTHDAY_CAKE: 'Cake',
  BOLD: 'Bold',
  BOLT: 'Zap',
  BOMB: 'Bomb',
  BOOK: 'Book',
  BOOKMARK: 'Bookmark',
  BOOKMARK_O: 'Bookmark',
  BRIEFCASE: 'Briefcase',
  BUG: 'Bug',
  BUILDING: 'Building',
  BUILDING_O: 'Building',
  BULLHORN: 'Megaphone',
  BULLSEYE: 'Target',
  BUS: 'Bus',
  CAB: 'Car',
  CALCULATOR: 'Calculator',
  CALENDAR: 'Calendar',
  CALENDAR_CHECK_O: 'CalendarCheck',
  CALENDAR_MINUS_O: 'CalendarMinus',
  CALENDAR_O: 'Calendar',
  CALENDAR_PLUS_O: 'CalendarPlus',
  CALENDAR_TIMES_O: 'CalendarX',
  CAMERA: 'Camera',
  CAMERA_RETRO: 'Camera',
  CAR: 'Car',
  CARET_DOWN: 'ChevronDown',
  CARET_LEFT: 'ChevronLeft',
  CARET_RIGHT: 'ChevronRight',
  CARET_UP: 'ChevronUp',
  CART_ARROW_DOWN: 'ShoppingCart',
  CART_PLUS: 'ShoppingCart',
  CERTIFICATE: 'Award',
  CHAIN: 'Link',
  CHAIN_BROKEN: 'Link2Off',
  CHECK: 'Check',
  CHECK_CIRCLE: 'CheckCircle',
  CHECK_CIRCLE_O: 'CheckCircle',
  CHECK_SQUARE: 'CheckSquare',
  CHECK_SQUARE_O: 'CheckSquare',
  CHEVRON_CIRCLE_DOWN: 'ChevronDown',
  CHEVRON_CIRCLE_LEFT: 'ChevronLeft',
  CHEVRON_CIRCLE_RIGHT: 'ChevronRight',
  CHEVRON_CIRCLE_UP: 'ChevronUp',
  CHEVRON_DOWN: 'ChevronDown',
  CHEVRON_LEFT: 'ChevronLeft',
  CHEVRON_RIGHT: 'ChevronRight',
  CHEVRON_UP: 'ChevronUp',
  CHILD: 'PersonStanding',
  CIRCLE: 'CircleDot',
  CIRCLE_O: 'Circle',
  CIRCLE_THIN: 'Circle',
  CLIPBOARD: 'Clipboard',
  CLOCK_O: 'Clock',
  CLONE: 'Copy',
  CLOSE: 'X',
  CLOUD: 'Cloud',
  CLOUD_DOWNLOAD: 'CloudDownload',
  CLOUD_UPLOAD: 'CloudUpload',
  CODE: 'Code',
  CODE_FORK: 'GitFork',
  COFFEE: 'Coffee',
  COG: 'Cog',
  COGS: 'Settings',
  COLUMNS: 'Columns',
  COMMENT: 'MessageCircle',
  COMMENT_O: 'MessageCircle',
  COMMENTING: 'MessageSquare',
  COMMENTING_O: 'MessageSquare',
  COMMENTS: 'MessageCircle',
  COMMENTS_O: 'MessageCircle',
  COMPASS: 'Compass',
  COMPRESS: 'Minimize',
  COPY: 'Copy',
  COPYRIGHT: 'Copyright',
  CREDIT_CARD: 'CreditCard',
  CREDIT_CARD_ALT: 'CreditCard',
  CROP: 'Crop',
  CROSSHAIRS: 'Crosshair',
  CUBE: 'Box',
  CUBES: 'Boxes',
  CUT: 'Scissors',
  CUTLERY: 'Utensils',
  DASHBOARD: 'LayoutDashboard',
  DATABASE: 'Database',
  DEDENT: 'Outdent',
  DESKTOP: 'Monitor',
  DIAMOND: 'Gem',
  DOLLAR: 'DollarSign',
  DOT_CIRCLE_O: 'Circle',
  DOWNLOAD: 'Download',
  EDIT: 'Edit',
  ELLIPSIS_H: 'MoreHorizontal',
  ELLIPSIS_V: 'MoreVertical',
  ENVELOPE: 'Mail',
  ENVELOPE_O: 'Mail',
  ENVELOPE_SQUARE: 'Mail',
  ERASER: 'Eraser',
  EURO: 'Euro',
  EUR: 'Euro',
  EXCHANGE: 'ArrowLeftRight',
  EXCLAMATION: 'AlertCircle',
  EXCLAMATION_CIRCLE: 'AlertCircle',
  EXCLAMATION_TRIANGLE: 'AlertTriangle',
  EXPAND: 'Maximize',
  EXPEDITEDSSL: 'Shield',
  EXTERNAL_LINK: 'ExternalLink',
  EXTERNAL_LINK_SQUARE: 'ExternalLink',
  EYE: 'Eye',
  EYE_SLASH: 'EyeOff',
  EYEDROPPER: 'Pipette',
  FAST_BACKWARD: 'Rewind',
  FAST_FORWARD: 'FastForward',
  FAX: 'Printer',
  FEED: 'Rss',
  FEMALE: 'User',
  FIGHTER_JET: 'Plane',
  FILE: 'File',
  FILE_ARCHIVE_O: 'FileArchive',
  FILE_AUDIO_O: 'FileAudio',
  FILE_CODE_O: 'FileCode',
  FILE_EXCEL_O: 'FileSpreadsheet',
  FILE_IMAGE_O: 'FileImage',
  FILE_O: 'File',
  FILE_PDF_O: 'File',
  FILE_PHOTO_O: 'FileImage',
  FILE_PICTURE_O: 'FileImage',
  FILE_POWERPOINT_O: 'FileText',
  FILE_TEXT: 'FileText',
  FILE_TEXT_O: 'FileText',
  FILE_VIDEO_O: 'FileVideo',
  FILE_WORD_O: 'FileText',
  FILE_ZIP_O: 'FileArchive',
  FILES_O: 'Files',
  FILM: 'Film',
  FILTER: 'Filter',
  FIRE: 'Flame',
  FIRE_EXTINGUISHER: 'FireExtinguisher',
  FLAG: 'Flag',
  FLAG_CHECKERED: 'Flag',
  FLAG_O: 'Flag',
  FLASH: 'Zap',
  FLASK: 'FlaskConical',
  FLOPPY_O: 'Save',
  FOLDER: 'Folder',
  FOLDER_O: 'Folder',
  FOLDER_OPEN: 'FolderOpen',
  FOLDER_OPEN_O: 'FolderOpen',
  FONT: 'Type',
  FORT_AWESOME: 'Castle',
  FORWARD: 'Forward',
  FROWN_O: 'Frown',
  FUTBOL_O: 'Volleyball',
  GAMEPAD: 'Gamepad',
  GAVEL: 'Gavel',
  GBP: 'PoundSterling',
  GEAR: 'Settings',
  GEARS: 'Settings',
  GIFT: 'Gift',
  GIT: 'GitBranch',
  GIT_SQUARE: 'GitBranch',
  GLASS: 'Wine',
  GLOBE: 'Globe',
  GOOGLE: 'Globe',
  GOOGLE_PLUS: 'Globe',
  GRADUATION_CAP: 'GraduationCap',
  GROUP: 'Users',
  H_SQUARE: 'Hospital',
  HAND_O_DOWN: 'ArrowDown',
  HAND_O_LEFT: 'ArrowLeft',
  HAND_O_RIGHT: 'ArrowRight',
  HAND_O_UP: 'ArrowUp',
  HAND_PAPER_O: 'HandMetal',
  HAND_PEACE_O: 'HandMetal',
  HAND_POINTER_O: 'MousePointer',
  HAND_ROCK_O: 'HandMetal',
  HAND_SCISSORS_O: 'Scissors',
  HAND_SPOCK_O: 'HandMetal',
  HAND_STOP_O: 'OctagonX',
  HASHTAG: 'Hash',
  HDD_O: 'HardDrive',
  HEADER: 'Heading',
  HEADPHONES: 'Headphones',
  HEART: 'Heart',
  HEART_O: 'Heart',
  HEARTBEAT: 'Activity',
  HISTORY: 'History',
  HOME: 'Home',
  HOSPITAL_O: 'Hospital',
  HOTEL: 'Hotel',
  HOURGLASS: 'Hourglass',
  HOURGLASS_END: 'Timer',
  HOURGLASS_HALF: 'Hourglass',
  HOURGLASS_O: 'Hourglass',
  HOURGLASS_START: 'TimerReset',
  I_CURSOR: 'Type',
  IMAGE: 'Image',
  INBOX: 'Inbox',
  INDENT: 'Indent',
  INDUSTRY: 'Factory',
  INFO: 'Info',
  INFO_CIRCLE: 'Info',
  INR: 'IndianRupee',
  INSTITUTION: 'Building',
  ITALIC: 'Italic',
  JPY: 'JapaneseYen',
  KEY: 'Key',
  KEYBOARD_O: 'Keyboard',
  LANGUAGE: 'Languages',
  LAPTOP: 'Laptop',
  LEAF: 'Leaf',
  LEGAL: 'Scale',
  LEMON_O: 'Citrus',
  LEVEL_DOWN: 'CornerDownRight',
  LEVEL_UP: 'CornerUpRight',
  LIFE_RING: 'LifeBuoy',
  LIGHTBULB_O: 'Lightbulb',
  LINE_CHART: 'LineChart',
  LINK: 'Link',
  LIST: 'List',
  LIST_ALT: 'List',
  LIST_OL: 'ListOrdered',
  LIST_UL: 'List',
  LOCATION_ARROW: 'Navigation',
  LOCK: 'Lock',
  LONG_ARROW_DOWN: 'ArrowDown',
  LONG_ARROW_LEFT: 'ArrowLeft',
  LONG_ARROW_RIGHT: 'ArrowRight',
  LONG_ARROW_UP: 'ArrowUp',
  MAGIC: 'Wand',
  MAGNET: 'Magnet',
  MAIL_FORWARD: 'Forward',
  MAIL_REPLY: 'Reply',
  MAIL_REPLY_ALL: 'ReplyAll',
  MALE: 'User',
  MAP: 'Map',
  MAP_MARKER: 'MapPin',
  MAP_O: 'Map',
  MAP_PIN: 'MapPin',
  MAP_SIGNS: 'Signpost',
  MARS_STROKE_H: 'MarsStroke',
  MEDKIT: 'BriefcaseMedical',
  MEH_O: 'Meh',
  MICROPHONE: 'Mic',
  MICROPHONE_SLASH: 'MicOff',
  MINUS: 'Minus',
  MINUS_CIRCLE: 'MinusCircle',
  MINUS_SQUARE: 'MinusSquare',
  MINUS_SQUARE_O: 'MinusSquare',
  MOBILE: 'Smartphone',
  MOBILE_PHONE: 'Smartphone',
  MONEY: 'DollarSign',
  MOON_O: 'Moon',
  MORTAR_BOARD: 'GraduationCap',
  MOTORCYCLE: 'Bike',
  MOUSE_POINTER: 'MousePointer',
  MUSIC: 'Music',
  NAVICON: 'Menu',
  NEWSPAPER_O: 'Newspaper',
  OBJECT_GROUP: 'Group',
  OBJECT_UNGROUP: 'Ungroup',
  OUTDENT: 'Outdent',
  PAGELINES: 'Leaf',
  PAINT_BRUSH: 'Paintbrush',
  PAPER_PLANE: 'Send',
  PAPER_PLANE_O: 'Send',
  PAPERCLIP: 'Paperclip',
  PARAGRAPH: 'Pilcrow',
  PASTE: 'Clipboard',
  PAUSE: 'Pause',
  PAUSE_CIRCLE: 'PauseCircle',
  PAUSE_CIRCLE_O: 'PauseCircle',
  PAW: 'PawPrint',
  PENCIL: 'Pencil',
  PENCIL_SQUARE: 'Edit',
  PENCIL_SQUARE_O: 'Edit',
  PERCENT: 'Percent',
  PHONE: 'Phone',
  PHONE_SQUARE: 'Phone',
  PHOTO: 'Image',
  PICTURE_O: 'Image',
  PIE_CHART: 'PieChart',
  PLANE: 'Plane',
  PLAY: 'Play',
  PLAY_CIRCLE: 'PlayCircle',
  PLAY_CIRCLE_O: 'PlayCircle',
  PLUG: 'Plug',
  PLUS: 'Plus',
  PLUS_CIRCLE: 'PlusCircle',
  PLUS_SQUARE: 'PlusSquare',
  PLUS_SQUARE_O: 'PlusSquare',
  POWER_OFF: 'Power',
  PRINT: 'Printer',
  PRODUCT_HUNT: 'CircleParking',
  PUZZLE_PIECE: 'Puzzle',
  QRCODE: 'QrCode',
  QUESTION: 'HelpCircle',
  QUESTION_CIRCLE: 'HelpCircle',
  QUOTE_LEFT: 'Quote',
  QUOTE_RIGHT: 'Quote',
  RANDOM: 'Shuffle',
  RECYCLE: 'Recycle',
  REFRESH: 'RefreshCw',
  REGISTERED: 'Copyright',
  REMOVE: 'X',
  REPEAT: 'Repeat',
  REPLY: 'Reply',
  REPLY_ALL: 'ReplyAll',
  RETWEET: 'Repeat',
  ROAD: 'Route',
  ROCKET: 'Rocket',
  ROTATE_LEFT: 'RotateCcw',
  ROTATE_RIGHT: 'RotateCw',
  RSS: 'Rss',
  RSS_SQUARE: 'Rss',
  SAVE: 'Save',
  SCISSORS: 'Scissors',
  SEARCH: 'Search',
  SEARCH_MINUS: 'SearchX',
  SEARCH_PLUS: 'SearchCheck',
  SEND: 'Send',
  SEND_O: 'Send',
  SERVER: 'Server',
  SHARE: 'Share',
  SHARE_ALT: 'Share2',
  SHARE_ALT_SQUARE: 'Share2',
  SHARE_SQUARE: 'Share',
  SHARE_SQUARE_O: 'Share',
  SHIELD: 'Shield',
  SHIP: 'Ship',
  SHOPPING_BAG: 'ShoppingBag',
  SHOPPING_BASKET: 'ShoppingBasket',
  SHOPPING_CART: 'ShoppingCart',
  SIGN_IN: 'LogIn',
  SIGN_OUT: 'LogOut',
  SIGNAL: 'Signal',
  SITEMAP: 'Network',
  SLIDERS: 'Sliders',
  SMILE_O: 'Smile',
  SOCCER_BALL_O: 'CircleDashed',
  SORT: 'ArrowUpDown',
  SORT_ALPHA_ASC: 'ArrowUpAZ',
  SORT_ALPHA_DESC: 'ArrowDownAZ',
  SORT_AMOUNT_ASC: 'TrendingUp',
  SORT_AMOUNT_DESC: 'TrendingDown',
  SORT_ASC: 'ArrowUp',
  SORT_DESC: 'ArrowDown',
  SORT_DOWN: 'ArrowDown',
  SORT_NUMERIC_ASC: 'ArrowUp01',
  SORT_NUMERIC_DESC: 'ArrowDown01',
  SORT_UP: 'ArrowUp',
  SPACE_SHUTTLE: 'Rocket',
  SPINNER: 'Loader',
  SPOON: 'Utensils',
  SQUARE: 'Square',
  SQUARE_O: 'Square',
  STAR: 'Star',
  STAR_HALF: 'StarHalf',
  STAR_HALF_EMPTY: 'StarHalf',
  STAR_HALF_FULL: 'StarHalf',
  STETHOSCOPE: 'Stethoscope',
  TAGS: 'Tags',
  THUMBS_UP: 'ThumbsUp',
  TRUCK: 'Truck',
  USER_PLUS: 'UserPlus',
  USER_SECRET: 'HatGlasses',
  WARNING: 'AlertTriangle',
  WRENCH: 'Wrench',
};
